import type { JSError } from './JSError';
import { ZodToObjectError } from './ZodToObjectError';
import { PojoToServerError } from './PojoToServerError';

type TKnownErrorHandler = {
  handlerKey: string;

  /**
   * Should return the JSError2 when knows how to map the error
   * else returns false
   */
  handle: (data: any) => JSError | null;
};

export const knownErrorRegistry = {
  knownErrors: [] as TKnownErrorHandler[],
  register: (handlerKey: string, handle: (data: any) => JSError | null) => {
    knownErrorRegistry.knownErrors.push({ handlerKey, handle });
  },
};

knownErrorRegistry.register('ZodToObjectError', ZodToObjectError);
knownErrorRegistry.register('PojoToServerError', PojoToServerError);
